import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class HttpLoggingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const fullUrl = req.url.startsWith('http')
      ? req.url
      : req.url.startsWith('/')
        ? `${typeof location !== 'undefined' ? location.origin : '[unknown]'}${req.url}`
        : `${environment.apiUrl}/${req.url}`;
    const startTime = performance.now();

    console.log('[ACFE] HTTP REQUEST:', {
      method: req.method,
      url: req.url,
      fullUrl,
      apiUrl: environment.apiUrl,
      withCredentials: req.withCredentials,
      headers: this.sanitizeHeaders(req.headers),
      body: req.body ? '(present)' : '(none)',
    });

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const duration = Math.round(performance.now() - startTime);
            console.log('[ACFE] HTTP RESPONSE:', {
              url: req.url,
              status: event.status,
              statusText: event.status.toString() ?? 'unknown',
              durationMs: duration,
              headers: this.sanitizeHeaders(event.headers),
            });
          }
        },
        error: (err: unknown) => {
          const duration = Math.round(performance.now() - startTime);
          const httpErr = err as HttpErrorResponse;
          console.error('[ACFE] HTTP ERROR:', {
            url: req.url,
            fullUrl,
            method: req.method,
            status: httpErr?.status ?? 'unknown',
            statusText: httpErr?.statusText ?? 'unknown',
            message: httpErr?.message ?? String(err),
            durationMs: duration,
            error: httpErr?.error,
            headers: httpErr?.headers ? this.sanitizeHeaders(httpErr.headers) : undefined,
          });
          if (httpErr?.status === 0) {
            console.warn(
              '[ACFE] HTTP status 0 often indicates CORS, network error, or request blocked. Check:',
              '\n  - CORS headers on server (Access-Control-Allow-Origin, etc.)',
              '\n  - Server is reachable from client origin',
              '\n  - withCredentials and allowed origins match',
            );
          }
        },
      }),
    );
  }

  private sanitizeHeaders(headers: {
    keys: () => string[];
    get: (name: string) => string | null;
  }): Record<string, string> {
    const out: Record<string, string> = {};
    for (const key of headers.keys()) {
      const value = headers.get(key);
      out[key] =
        key.toLowerCase() === 'authorization' ? (value ? '[REDACTED]' : '') : (value ?? '');
    }
    return out;
  }
}
